import { axiosInstance } from 'src/config/axiosInstance';

class UsersService {
  static async fetchUsersSummary(companyId, maxRetries, retryDelay) {
    let retries = 0;
    while (retries < maxRetries) {
      try {
        const response = await axiosInstance.get(`/users/summary/${companyId}`);

        return response;
      } catch (error) {
        console.error('An error occurred:', error);
        retries++;
        await new Promise((resolve) => setTimeout(resolve, retryDelay));
      }
    }
    return [];
  }

  static async fetchUserDetails(projectId, maxRetries, retryDelay) {
    let retries = 0;
    while (retries < maxRetries) {
      try {
        const response = await axiosInstance.get(`/users/user/${projectId}`);

        return response;
      } catch (error) {
        console.error('Error fetching project details:', error);
        retries++;
        await new Promise((resolve) => setTimeout(resolve, retryDelay));
      }
    }
  }
}

export default UsersService;
